export enum AgentRole {
  User = 'user',
  Assistant = 'assistant',
}

export interface AgentMessage {
  role: AgentRole;
  content: string;
  i18nKey?: string;
  timestamp?: Date;
}

export enum AgentFeature {
  Onsite = 'onsite',
  Offsite = 'offsite',
  BulkRetargeting = 'bulk-retargeting',
}

export interface AgentQueryRequest {
  query: string;
  siteId: string;
  feature: AgentFeature;
  conversationHistory?: AgentMessage[];
  context?: {
    siteId?: string;
    filters?: {
      status?: string;
      name?: string;
      session_timeout?: string;
    };
  };
}

export interface AgentQueryResponse {
  response: string;
  data?: any; // atm we only get campaign data from the agent(s). Might be worth it typing it when we start implementing differently scoped agents.
}
